export const ID = {
  "Open document": "Buka dokumen",
  "Upload file": "Unggah data",
  "Drop file here to upload": "Jatuhkan file di sini untuk mengunggah",
  "Disc": "Cakram",
  "URL": "URL",
  "FILE": "MENGAJUKAN",
  "SIZE": "UKURAN",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Byte",
  "Loading... Please wait.": "Sedang memuat... Harap tunggu.",
  "Fit Width": "Cocok Lebar",
  "Fit Height": "Cocok Tinggi",
  "Password protected document": "Dokumen yang dilindungi kata sandi",
  "Password": "Kata sandi",
  "Open": "Membuka",
  "Password Required": "Diperlukan Kata Sandi",
  "Incorrect password": "kata kunci Salah",
  "Error": "Kesalahan",
  "Something went wrong": "Ada yang salah",
  "Server is not available": "Server tidak tersedia",
  "of": "dari",
  "Please wait...": "Mohon tunggu..."
};
